import { API_PREFIX } from './api.constants';

const PREFIX = `${API_PREFIX}/context-roles`;

/**
 * Context role assignments (full-hierarchy permission grants).
 * Mirrors `context_roles_router.py` in useradmin.
 */
export const CONTEXT_ROLE_ENDPOINTS = {
  BASE: PREFIX,
  EFFECTIVE: `${PREFIX}/effective`,
  ASSIGNABLE_ROLES: `${PREFIX}/assignable-roles`,
  /** What the signed-in person may create through category (context) roles — see useScopedCapabilities. */
  MY_CAPABILITIES: `${PREFIX}/me/capabilities`,
  ONE: (id: number | string) => `${PREFIX}/${id}`,
};
